import React, { Fragment } from 'react';
import styled from 'styled-components';

import ModalWrapper from './ModalWrapper';
import HappinessExtravaganza from 'components/HappinessExtravaganza';

const Content = styled.div`
  p {
    font-size: 16px;
    margin: 0 0 25px;
  }

  .Debt__celebration {
    font-size: 48px;
    text-align: center;
    line-height: 1;
  }

  .Debt__tada {
    display: inline-block;
    margin: 0 10px;
  }
`;

const AlertModal = ({ debt, ...props }) => {
  return (
    <Fragment>
      <ModalWrapper
        {...props}
        cancelButton={false}
        closeText="Yay! I'm Amazing!"
        title={`YOU PAID OFF ${debt.name}!!!`.toUpperCase()}
        width={500}
      >
        <Content>
          <p>Take a second to pat yourself on the back and bust out some boxed wine!</p>
          <div className="Debt__celebration">
            <span className="Debt__tada" role="img" aria-label="WHOO!">
              🎉
            </span>
            <span className="Debt__tada" role="img" aria-label="WHOO!">
              🎉
            </span>
            <span className="Debt__tada" role="img" aria-label="WHOO!">
              🎉
            </span>
          </div>
        </Content>
      </ModalWrapper>
      <HappinessExtravaganza />
    </Fragment>
  );
};

export default AlertModal;



// WEBPACK FOOTER //
// ./src/components/Modals/DebtPaidModal.js